(() => {
  // Delegation also covers replaced Shopify sections. Install only once.
  if (window.productQualityBadgeInitialized) return;
  window.productQualityBadgeInitialized = true;

  const anchorSelector = '.section-main-product .product__quality-anchor';
  const buttonSelector = '.product__quality-info';

  const placeTooltip = (anchor) => {
    const tooltip = anchor.querySelector('.product__quality-tooltip');
    if (!tooltip) return;
    anchor.style.removeProperty('--product-quality-tooltip-offset');
    const anchorRect = anchor.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const edge = 16;
    let offset = 0;
    if (anchorRect.left + tooltipRect.width > window.innerWidth - edge) {
      offset = window.innerWidth - edge - anchorRect.left - tooltipRect.width;
    }
    if (anchorRect.left + offset < edge) offset = edge - anchorRect.left;
    anchor.style.setProperty('--product-quality-tooltip-offset', `${offset}px`);
  };

  const close = (anchor) => {
    anchor.querySelector(buttonSelector)?.setAttribute('aria-expanded', 'false');
    // Escape/click must also dismiss the CSS hover preview under the pointer.
    anchor.toggleAttribute('data-quality-dismissed', anchor.matches(':hover'));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    const anchor = button?.closest(anchorSelector);
    document.querySelectorAll(anchorSelector).forEach((other) => {
      if (other !== anchor && !other.querySelector('.product__quality-tooltip')?.contains(event.target)) close(other);
    });
    if (!anchor) return;
    if (button.getAttribute('aria-expanded') === 'true') {
      close(anchor);
    } else {
      anchor.removeAttribute('data-quality-dismissed');
      button.setAttribute('aria-expanded', 'true');
      placeTooltip(anchor);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(anchorSelector).forEach(close);
  });

  document.addEventListener('pointerover', (event) => {
    const anchor = event.target.closest(anchorSelector);
    if (anchor) placeTooltip(anchor);
  });

  document.addEventListener('pointerout', (event) => {
    const anchor = event.target.closest(anchorSelector);
    if (anchor && !anchor.contains(event.relatedTarget)) anchor.removeAttribute('data-quality-dismissed');
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(`${anchorSelector}:has(${buttonSelector}[aria-expanded="true"])`).forEach(placeTooltip);
  });
})();
